import React from 'react'

import {TableHeaderRow} from "@devexpress/dx-react-grid-material-ui"
import {Filter} from "../Filter"

export const TableHeaderContent = (props) => {
    const {column, dictionary, filter, setFilter, children, ...restProps} = props

    let button = null

    if (dictionary.attributes.length && dictionary.attributes.find(attribute => `attributes.${attribute.id}` === column.name)) {
        button = <Filter name={column.name} dictionary={dictionary.id} filter={filter} setFilter={setFilter}/>
    }

    switch (column.name) {
        case 'value':
        case 'active':
        case 'pipeline':
        case 'created':
        case 'updated':
        case 'category':
            button = <Filter name={column.name} dictionary={dictionary.id} filter={filter} setFilter={setFilter}/>
            break
        default:
            break
    }

    return (
        <TableHeaderRow.Content
            column={column}
            {...restProps}
            style={{
                justifyContent: 'space-between'
            }}
        >
            {children}
            {button}
        </TableHeaderRow.Content>
    )
}
